import { ChangeEvent } from "react";
import { TranslationService } from "../../../../services/TranslationService";
import { RequiredManager } from "../../../shared/RequieredManager";
import { CriterionModel, Operator } from "../../providers/CriteriaContext";
import Dropdown from "../../../shared/components/Dropdown";
import { InputWithValidation } from "./InputWithValidation";

type DateCriterionProps = {
  data: CriterionModel;
  dateOperators: any[];
  inputResetKey: number;
  onOperatorChange: (value: number) => void;
  onValueChange: (e: ChangeEvent<HTMLInputElement>) => void;
  requiredManager: RequiredManager;
};

export const DateCriterion = ({
  data,
  dateOperators,
  inputResetKey,
  onOperatorChange,
  onValueChange,
  requiredManager
}: DateCriterionProps) => {
  return (
    <>
      <Dropdown
        selectClasses=""
        onChange={onOperatorChange}
        items={dateOperators}
        defaultValue={data.Operator}
      />
      {![Operator.Empty, Operator.NotEmpty].includes(data.Operator) && (
        <InputWithValidation
          inputResetKey={inputResetKey}
          type="number"
          item={data}
          filterKey="Value"
          callback={onValueChange}
          requiredManager={requiredManager}
          boxLeft={false}
          withBox={true}
          boxText={TranslationService.translate.Days}
        />
      )}
    </>
  );
};
